<template>
  <v-container fluid class="purchaseorder-list mt-3">
    <v-row class="ma-0">
      <v-card width="100%" class="ma-1">
        <v-card-text>
          <v-row no-gutters>
            <v-col cols="12" sm="12" md="12" lg="12" class="d-flex flex-start justify-md-start overflow-auto">
              <v-btn to="/purchaseorder/add" color="success" class="button-shadow mr-2">
                <v-icon class="mr-2">mdi-plus</v-icon>
                Add
              </v-btn>
              <v-btn color="success" class="button-shadow mr-2" @click="isFindOrder=true">
                <v-icon class="mr-2">mdi-file-search</v-icon>
                Find
              </v-btn>
              <v-btn color="primary" class="button-shadow mr-2" @click="makePaymentList">
                <v-icon class="mr-2">mdi-cash-plus</v-icon>
                Pay
              </v-btn>
              <v-btn color="primary" class="button-shadow mr-2" @click="makePurchaseReceipt">
                <v-icon class="mr-2">mdi-package-variant-closed-plus</v-icon>
                Receive
              </v-btn>
              <download-excel
                class="btn btn-default"
                :data="getJson()"
                worksheet="My Worksheet"
                type="csv"
                :name="getFileName()"
              >
              <v-btn 
                v-show="data_orders.length>0"
                color="default" 
                class="button-shadow mb-2 mr-0 mr-sm-2"
              >
                <v-icon class="mr-2">mdi-microsoft-excel</v-icon>
                Save
              </v-btn>
              </download-excel>
              <v-btn to="/batchpayment/list" color="default" class="button-shadow mr-2">
                <v-icon class="mr-2">mdi-file-multiple</v-icon>
                Payments
              </v-btn>
              <v-btn to="/purchasereceipt/list" color="default" class="button-shadow mr-2">
                <v-icon class="mr-2">mdi-file-multiple</v-icon>
                Receipts
              </v-btn>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-row>
    <v-row>
      <v-col cols="12">
        <v-card class="ma-1">
          <v-card-text>
            <v-data-table
              :loading="isReceiving || isDeleting"
              loading-text="Loading... Please wait"
              class="purchaseorders-table"
              show-select
              single-select
              v-model="data_selected"
              item-key="_id"
              sort-desc
              sort-by="purchaseorderdate"
              :footer-props="footer"
              :headers="headers"
              :items="data_orders"
              :items-per-page="itemPerPage">
              <template v-slot:top>
                <v-dialog
                  v-model="isDeleteOrder"
                  width="500"
                >
                  <v-card>
                    <v-card-title>
                      Delete this Purchase Order?
                    </v-card-title>
                    <v-card-text>
                      {{ delete_order.purchaseordernum }} 
                      {{ delete_order.purchaseordername }}
                    </v-card-text>
                    <v-divider></v-divider>
                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn color="primary" outlined @click="isDeleteOrder = false">Cancel</v-btn>
                      <v-btn color="secondary" class="button-shadow" @click="deleteItem(delete_order)">Delete</v-btn>
                    </v-card-actions>
                  </v-card>
                </v-dialog>
              </template>
              <template v-slot:item.userid="{ item }">
                <v-avatar v-if="users.length>0 && users.find(user=>user._id == item.userid)['userimage']!==''" size="40">
                  <img v-bind:src="users.find(user=>user._id == item.userid)['userimage']" alt="">
                </v-avatar>
                <v-avatar
                  v-else
                  color="warning"
                  size="40">
                  <span class="white--text headline">{{ users.length>0 ? users.find(user=>user._id == item.userid)['username'][0].toUpperCase() : '' }}</span>
                </v-avatar>
                <span style="margin-left:15px">{{ users.length>0 ? users.find(user=>user._id == item.userid)['username'] : '' }} </span>
              </template>
              <template v-slot:item.purchaseorderimage="{ item }">
                    <v-img
                    v-if="item.purchaseorderimage" 
                    v-bind:src="item.purchaseorderimage"
                    max-height="100"
                    max-width="100"
                  ></v-img>
              </template>

              <template v-slot:item.purchaseordernum="{ item }">
                <p class="two-line">{{ item.purchaseordertype  }}</p>
                <p class="two-line">{{ item.purchaseordernum  }}</p>
                <p class="two-line">{{ new Date(item.purchaseorderdate).toLocaleString("en-SG", { year: 'numeric', month: 'numeric', day: 'numeric' })  }}</p>
              </template>
              <template v-slot:item.purchaseorderaddress="{ item }">
                <p class="two-line">{{ item.purchaseorderaddress }}</p>
              </template>
              <template v-slot:item.payments="{ item }">
                <div v-if="item.payments" style="font-size: 10pt;">{{ item.payments.map(item=>new Date(item.transdate).toLocaleString("en-SG", { year: '2-digit', month: '2-digit', day: 'numeric' }) + ':&nbsp;&nbsp;' + `$${item.transamount.toFixed(2)}`).join('\n') }}</div>
              </template>
              <template v-slot:item.purchaseordertotal="{ item }">
                <p class="two-line">{{ item.purchaseordertotal.toFixed(2) }}</p>
              </template>
              <template v-slot:item.paymentamount="{ item }">
                <p class="two-line">{{ item.paymentamount!=null ? item.paymentamount.toFixed(2) : 0 }}</p>
              </template>
              <template v-slot:item.receivedquantity="{ item }">
                <p class="two-line">{{ item.receivedquantity!=null ? item.receivedquantity.toFixed(0) : 0 }}</p>
              </template>
              <template v-slot:item.usedquantity="{ item }">
                <p class="two-line">{{ item.usedquantity!=null ? item.usedquantity.toFixed(0) : 0 }}</p>
              </template>
              <template v-slot:item.purchaseorderstatus="{ item }">
                <v-chip
                  :color="getStatusColor(item.purchaseorderstatus)"
                  small
                >
                  {{ item.purchaseorderstatus }}
                </v-chip>
              </template>
              <template v-slot:item.createdAt="{ item }">
                {{ new Date(item.createdAt).toLocaleString("en-SG", { year: 'numeric', month: 'numeric', day: 'numeric' }) }}
              </template>
              <template v-slot:item.actions="{ item }">
                <v-btn icon color="primary" @click="viewItem(item)">
                  <v-icon>mdi-magnify</v-icon>
                </v-btn>
                <v-btn v-if="['New', 'Partial', 'Completed'].indexOf(item.purchaseorderstatus)!=-1" icon color="primary" @click="editItem(item)">
                  <v-icon>mdi-pencil-outline</v-icon>
                </v-btn>
                <v-btn icon color="primary" @click="printItem(item)">
                  <v-icon>mdi-printer</v-icon>
                </v-btn>
                <v-btn v-if="item.purchaseorderstatus=='New'" icon color="primary" @click="deleteOrderDialog(item)">
                  <v-icon>mdi-delete-outline</v-icon>
                </v-btn>
              </template>
            </v-data-table>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
    <div>
      <v-dialog
        v-model="isFindOrder"
        persistent
        max-width="600px"
      >
        <v-card>
          <v-card-title>
            <span class="text-h5">Find Purchase Orders</span>
          </v-card-title>
          <v-card-text>
            <v-container>
              <v-row>
                <v-col cols="12" sm="6" md="6">
                  <v-select
                    :items="locations.filter(x=>x.locationstatus=='Active').map(x => {
                              return {text: x.locationname, value: x._id};
                            })"
                    v-model="find_query.locationid"
                    label="Location"
                    required
                    dense
                  ></v-select>
                </v-col>
                <v-col cols="12" sm="6" md="6">
                  <v-select
                    :items="vendors.filter(x=>x.vendorstatus=='Active' && x.vendortype=='Supplier').map(x => {
                              return {text: x.vendorname, value: x._id};
                            })"
                    v-model="find_query.vendorid"
                    label="Vendor"
                    required
                    dense
                  ></v-select>
                </v-col>
                <v-col cols="12" sm="6" md="6">
                  <v-select
                    :items="['New', 'Pending', 'Partial', 'Completed', 'Audit', 'Void']"
                    v-model="find_query.purchaseorderstatus"
                    label="Status"
                    required
                    dense
                  ></v-select>
                </v-col>
                <v-col cols="12" sm="6" md="6">
                  <v-text-field
                    class="mb-4"
                    type="number"
                    placeholder="Order Num"
                    v-model="find_query.purchaseordernum"
                    dense
                    oninput="if(this.value < 1) this.value = 1;"
                    single-line hint="Order Num">
                  </v-text-field>
                </v-col>
                <v-col cols="12" sm="6" md="6">
                          <v-menu
                            ref="menu_startdate"
                            v-model="menu_startdate"
                            :close-on-content-click="false"
                            :return-value.sync="find_query.startdate"
                            transition="scale-transition"
                            offset-y
                            min-width="auto"
                          >
                            <template v-slot:activator="{ on, attrs }">
                              <v-text-field
                                dense
                                v-model="find_query.startdate"
                                label="Start Date"
                                v-bind="attrs"
                                v-bind:value="find_query.startdate"
                                v-on="on"
                                persistent-hint
                                single-line hint="Please enter start date">
                              ></v-text-field>
                            </template>
                            <v-date-picker
                              v-model="find_query.startdate"
                              no-title
                              scrollable
                            >
                              <v-spacer></v-spacer>
                              <v-btn
                                text
                                color="primary"
                                @click="menu_startdate = false"
                              >
                                Cancel
                              </v-btn>
                              <v-btn
                                text
                                color="primary"
                                @click="$refs.menu_startdate.save(find_query.startdate)"
                              >
                                OK
                              </v-btn>
                            </v-date-picker>
                          </v-menu>
                </v-col>
                <v-col cols="12" sm="6" md="6">
                          <v-menu
                            ref="menu_enddate"
                            v-model="menu_enddate"
                            :close-on-content-click="false"
                            :return-value.sync="find_query.enddate"
                            transition="scale-transition"
                            offset-y
                            min-width="auto"
                          >
                            <template v-slot:activator="{ on, attrs }">
                              <v-text-field
                                dense
                                v-model="find_query.enddate"
                                label="End Date"
                                v-bind="attrs"
                                v-bind:value="find_query.enddate"
                                v-on="on"
                                persistent-hint
                                single-line hint="Please enter end date">
                              ></v-text-field>
                            </template>
                            <v-date-picker
                              v-model="find_query.enddate"
                              no-title
                              scrollable
                            >
                              <v-spacer></v-spacer>
                              <v-btn
                                text
                                color="primary"
                                @click="menu_enddate = false"
                              >
                                Cancel
                              </v-btn>
                              <v-btn
                                text
                                color="primary"
                                @click="$refs.menu_enddate.save(find_query.enddate)"
                              >
                                OK
                              </v-btn>
                            </v-date-picker>
                          </v-menu>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="blue darken-1"
              text
              @click="isFindOrder = false"
            >
              Close
            </v-btn>
            <v-btn
              color="blue darken-1"
              text
              @click="resetFind"
            >
              Reset
            </v-btn>
            <v-btn
              color="blue darken-1"
              text
              @click="findPurchaseOrders"
            >
              Find
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </div>
  </v-container>
</template>

<script>
import config from "../../../config"
import { mapState, mapActions } from 'vuex';
import { getStatusColor } from '@/util/tools';

export default {
  name: 'PurchaseOrderList',
  data() {
    return {
      config,
      isDeleteOrder: false,
      isFindOrder: false,
      menu_startdate: null,
      menu_enddate: null,
      delete_order: {},
      find_query: {},
      headers: [
        { text: 'Image', value: 'purchaseorderimage', sortable: false, width: '5%' },
        { text: 'Order', value: 'purchaseordernum', sortable: false, width: '12%' },
        { text: 'Name', value: 'purchaseordername' },
        { text: 'Amount', value: 'purchaseordertotal', width: '10%' },
        { text: 'Paid', value: 'paymentamount', width: '10%' },
        { text: 'Rcvd', value: 'receivedquantity', width: '8%' },
        { text: 'Used', value: 'usedquantity', width: '8%' },
        { text: 'Status', value: 'purchaseorderstatus', width: '10%' },
        { text: 'Actions', value: 'actions', sortable: false, width: '10%' },
      ],
      footer: {'items-per-page-options': [500, 1000, 5000]},
      itemPerPage: 500,
      data_selected: [],
      data_orders: [],
      getStatusColor: getStatusColor,
    }
  },
  computed: {
    ...mapState('PurchaseOrder', ['purchaseorders', 'isReceiving', 'isDeleting', 'idToDelete', 'purchaseordersMessage', 'isUpdating']),
    ...mapState('Location', ['locations']),
    ...mapState('User', ['users']),
    ...mapState('Vendor', ['vendors']),
  },

  methods: {
    ...mapActions('Vendor', ["getVendorsRequest"]),
    ...mapActions('Location', ["getLocationsRequest"]),
    ...mapActions('PurchaseOrder', ["getPurchaseOrdersRequest", "findPurchaseOrdersRequest", "deletePurchaseOrderRequest","updatePurchaseOrderRequest","createPurchaseOrderRequest"]),
    ...mapActions('User', ["getUsersRequest"]),
    checkError(){
      if(this.data_selected.length==0) return false;
      if(this.data_selected.find(item=>item.purchaseorderstatus=='Completed')!=null) return false;
      return true;
    },
    checkBills(){
      return this.data_selected.filter(item=>item.purchaseorderstatus=='Completed').map(item=>item.purchaseordernum.toString()).join(', ');
    },
    editItem(item) {
      this.$router.push({ name: 'PurchaseOrderEdit', params: item })
    },
    getJson(){
      let json = this.data_orders.map(order=>{return {
        order_num: order.purchaseordernum, 
        order_date: order.purchaseorderdate!=null ? new Date(order.purchaseorderdate).toLocaleString("en-SG", { year: 'numeric', month: 'numeric', day: 'numeric' }) : '',
        order_type: order.purchaseordertype,
        reference: order.refnum,
        order_name: order.purchaseordername, 
        location: order.locationid!=null && this.locations.length>0 ? this.locations.find(i=>i._id==order.locationid)['locationname'] : '',
        status: order.purchaseorderstatus,
        subtotal: order!=null ? order.purchaseordersubtotal.toFixed(2): '',
        total: order!=null ? order.purchaseordertotal.toFixed(2): '',
        rate: order.currencyRate,
        tax: order.isTaxable,
      }});
      return json;
    },
    getFileName(){
      var d = new Date();
      var name = 'purchase-orders-' + d.getFullYear() + '-' + (d.getMonth()+1).toString() + '-' + d.getDate() + '-' + (d.getHours().toString() +d.getSeconds().toString());
      return name + '.csv';
    },
    printItem(item) {
      this.$router.push({ name: 'PurchaseOrderPrint', params: item })
    },
    viewItem(item) {
      this.$router.push({ name: 'PurchaseOrderView', params: item })
    },
    makePurchaseReceipt(){
      if(this.data_selected.length==0) return;
      let item = this.data_selected[0];
      if(item.purchaseorderstatus=='Completed') return;
      this.$router.push({ name: 'PurchaseReceiptAdd', params: item })
    },
    makePaymentList(){
      if(!this.checkError()) {
        if(this.data_selected.length==0) this.error_message='No Purchase selected';
        else this.error_message='The following purchases cannot be paid:  ' + this.checkBills();
        this.isAlert=true; 
        return;
      }
      let bills = Object.assign([], this.data_selected);
      let json = {bills: bills, isPurchases: true};
      json['_isFrom'] = this.$route.name;
      this.$router.push({ name: 'BatchPaymentAdd', params: json });
    },
    async findPurchaseOrders(){
      this.isFindOrder = false;
      if(Object.keys(this.find_query).length==0){
        await this.getPurchaseOrdersRequest();
        this.data_orders = Object.assign([], this.purchaseorders);
      }
      else{
        let result = await this.findPurchaseOrdersRequest(this.find_query);
        this.data_orders = Object.assign([], result);
      }
    },
    async resetFind(){
      this.find_query = {};

    },
    deleteItem(item) {
      this.deletePurchaseOrderRequest({_id: item._id});
      this.isDeleteOrder = false;
    },
    deleteOrderDialog(item) {
      this.isDeleteOrder = true;
      this.delete_order = { _id: item._id, purchaseordernum: item.purchaseordernum, purchaseordername: item.purchaseordername }
    },

  },
  async created () {
      if(this.purchaseorders.length==0) await this.getPurchaseOrdersRequest();
      this.data_orders = Object.assign([], this.purchaseorders);
      if(this.vendors.length==0) await this.getVendorsRequest();
      if(this.locations.length==0) await this.getLocationsRequest();
      if(this.users.length==0) await this.getUsersRequest();
    },
}
</script>

<style src="./List.scss" lang="scss"></style>
